<template>
  <div>
    <v-dialog scrollable v-model="dialogs.delete" persistent max-width="400">
      <material-card
        v-if="editedItem"
        :title="
        selectedPlan && selectedPlan.PlanType === 'Pension'?$t('components.dependants.deactivate_dependant_{0}', [editedItem.Name])
          :$t('components.dependants.terminate_dependant_{0}', [editedItem.Name])
        "
        :color="$vuetify.theme.themes.light.error"
        icon="delete"
      >
        <v-card-text>
          <v-form ref="deleteForm" v-model="deleteValid">
            <v-container fluid>
              <v-row>
                <v-col xs="12">
                  <pbas-date-picker
                    :label="$t('components.inmemorydependants.effective_date')"
                    :value="effectiveDate"
                    @update-date="effectiveDate = $event"
                    :rules="[$rules.required]"
                    class="required"
                    :allowedDates="coverageAllowedDates"
                  ></pbas-date-picker>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="dialogs.delete = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!deleteValid"
            color="error"
            text
            @click="tryDelete"
          >
            {{ selectedPlan && selectedPlan.PlanType === 'Pension'?$t('globals.deactivate')
          :$t("globals.continue") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="dialogs.edit" persistent max-width="800px">
      <dependant-form
        v-if="editedItem"
        :title="formTitle"
        :identityId="editedItem.IdentityId"
        :editedIndex="editedIndex"
        :memberId="memberId"
        @save="saveDone"
        @close="close"
        :coverageEffectiveDate="coverageEffectiveDate"
        :policyIdentities="policyIdentities"
        :beneficiaryStatements="beneficiaryStatements"
      ></dependant-form>
    </v-dialog>

    <pbas-data-table
      v-if="disabled"
      ref="table"
      :dataProvider="provider"
      fileNamePrefix="dependants"
      :canExpand="(item) => item.Identity.HasHistory"
      :showExpand="true"
      :generateProviderForExpanded="(item) => generateDependantProvider(item)"
      @itemsChanged="setData($event)"
      :identifier="identifier"
      @error="error = $event"
    ></pbas-data-table>
    <template v-else>
      <pbas-data-table
        v-if="selectedPlan && selectedPlan.PlanType === 'Pension'"
        ref="table"
        :dataProvider="provider"
        :rowActions="spouseRowActions"
        :floatActions="floatActions"
        fileNamePrefix="dependants"
        :canExpand="(item) => item.Identity.HasHistory"
        :showExpand="true"
        :generateProviderForExpanded="(item) => generateDependantProvider(item)"
        @itemsChanged="setData($event)"
        :identifier="identifier"
        @error="error = $event"
      ></pbas-data-table>
      <pbas-data-table
        v-else
        ref="table"
        :dataProvider="provider"
        :rowActions="rowActions"
        :floatActions="floatActions"
        fileNamePrefix="dependants"
        :canExpand="(item) => item.Identity.HasHistory"
        :showExpand="true"
        :generateProviderForExpanded="(item) => generateDependantProvider(item)"
        @itemsChanged="setData($event)"
        :identifier="identifier"
        @error="error = $event"
      ></pbas-data-table>
    </template>
    <v-snackbar
      v-model="snackbar"
      :color="color"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
      :vertical="mode === 'vertical'"
    >
      {{ $t(message) }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
    <!-- </material-card> -->
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import getDependantsHeaders from "../headers/Dependants";
import TransSelect from "../components/TransSelect";
import { locker } from "../mixins/locker";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import DependantForm from "./DependantForm";
export default {
  name: "dependants",
  components: {
    ErrorHandler,
    TransSelect,
    DependantForm,
  },
  props: [
    "identifier",
    "memberId",
    "provider",
    "formTitle",
    "coverageEffectiveDate",
    "disabled",
    "policyIdentities",
    "beneficiaryStatements",
    "planType"
  ],
  mixins: [locker],
  data() {
    return {
      deleteValid: true,
      effectiveDate: null,
      error: null,
      valid: true,
      items: [],
      saving: false,
      floatActions: [],
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => this.editItem(item),
          visible: (item) => this.disabled !== true && item.IsRemoved !== true,
        },
        {
          name: "delete",
          icon: "delete",
          title: "globals.terminate",
          handler: (item) => {
            this.editedIndex = this.items.indexOf(item);
            this.editedItem = JSON.parse(JSON.stringify(item));
            this.dialogs.delete = true;
          },
          visible: (item) => this.disabled !== true && item.IsRemoved !== true,
        },
      ],
      spouseRowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => this.editItem(item),
          visible: (item) => this.disabled !== true && item.IsRemoved !== true,
        },
        {
          name: "delete",
          icon: "delete",
          title: "globals.deactivate",
          handler: (item) => {
            this.editedIndex = this.items.indexOf(item);
            this.editedItem = JSON.parse(JSON.stringify(item));
            this.dialogs.delete = true;
          },
          visible: (item) => this.disabled !== true && item.IsRemoved !== true,
        },
      ],
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      e6: 1,
      dialogs: {
        edit: false,
        delete: false,
      },
      headers: [],
      editedIndex: -1,
      editedItem: null,
      defaultItem: {},
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", {
      columnsDropDownOptions: "options",
      planParameters: "planOptions",
    }),
    formIcon() {
      return this.editedIndex === -1 ? "add" : "edit";
    },
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("common", ["settings"]),
  },
  watch: {
    disabled: {
      immediate: true,
      handler(v) {
        if (v) {
          if (this.provider) {
            this.provider.items = v;
            this.$refs.table.getDataAsync();
          }
        }
      },
    },
    effectiveDate: {
      async handler(v) {
        if (v) {
          try {
            let editedItem = this.defaultItem;
            if (this.editedIndex > -1) {
              if (this.dialogs.edit) {
                editedItem = await this.lock(
                  this.getByEffectiveDate,
                  {
                    entity: "dependants",
                    plan: this.selectedPlan.Id,
                    id: this.editedItem.IdentityId,
                    date: v,
                    expand:
                      "$expand=Relationship($select=Name,Id,IsChild,IsSpouse;$expand=Translations($select=LanguageCode,DisplayValue)),Gender($select=Name,Id;$expand=Translations($select=LanguageCode,DisplayValue))&$select=Id,IdentityId,EffectiveDate,RelationshipId,FirstName,MiddleName,LastName,GenderId,DateOfBirth",
                    dialogs: this.dialogs,
                    dialog: "edit",
                  },
                  () => {
                    this.dialogs.edit = false;
                  }
                );
              } else if (this.dialogs.delete) {
                editedItem = await this.lock(
                  this.getByEffectiveDate,
                  {
                    entity: "dependants",
                    plan: this.selectedPlan.Id,
                    id: this.editedItem.IdentityId,
                    date: v,
                    dialogs: this.dialogs,
                    dialog: "delete",
                  },
                  () => {
                    this.dialogs.delete = false;
                  }
                );
              }
            } else {
              await this.lock(
                this.lockWizard,
                {
                  plan: this.memberId,
                  dialogs: this.dialogs,
                  dialog: "edit",
                },
                () => {
                  this.dialogs.edit = false;
                }
              );
              editedItem = JSON.parse(JSON.stringify(this.defaultItem));
            }
            this.editedItem = editedItem;
          } catch (error) {
            this.error = error;
          }
        }
      },
    },
  },
  mounted() {
    if (this.planType) {
      this.headers = getDependantsHeaders(this.planType);
    } else {
    this.headers = getDependantsHeaders(this.selectedPlan.PlanType);
    }
  },
  methods: {
    ...mapActions("plansMembers", [
      "getByEffectiveDate",
      "updateDependant",
      "lockWizard",
    ]),
    coverageAllowedDates(val) {
      console.log(this.coverageEffectiveDate);
      const n = Date.parse(val);
      const d = new Date(n);
      let n2 = Date.parse(this.coverageEffectiveDate);
      const d2 = new Date(n2);
      return d >= d2;
    },
    generateDependantProvider(item) {
      const url =
        "plans/" +
        this.selectedPlan.Id +
        "/members/" +
        this.memberId +
        "/dependants/" +
        item.IdentityId +
        "/history";
      return new PbasOData(
        this.$axiosHttp,
        url,
        this.headers.filter(
          (o) =>
            (o.visible === true && o.allowVisibilityChange === true) ||
            o.allowVisibilityChange === false
        )
      );
    },
    reload() {
      this.$refs.table.getDataAsync();
    },
    setData(items) {
      this.items = items;
    },
    editItem(item) {
      // let dep;
      // if (item.Id) {
      //   dep = this.items.filter(o => o.Id === item.Id)[0];
      // } else {
      //   dep = this.items.filter(
      //     o => o.FirstName === item.FirstName && o.LastName === item.LastName
      //   )[0];
      // }
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = JSON.parse(JSON.stringify(item));
      this.dialogs.edit = true;
    },
    addItem(item) {
      // let dep;
      // if (item.Id) {
      //   dep = this.items.filter(o => o.Id === item.Id)[0];
      // } else {
      //   dep = this.items.filter(
      //     o => o.FirstName === item.FirstName && o.LastName === item.LastName
      //   )[0];
      // }
      this.editedIndex = -1;
      this.editedItem = JSON.parse(JSON.stringify(item));
      this.dialogs.edit = true;
    },
    close() {
      if (this.$refs.dependantForm) this.$refs.dependantForm.resetValidation();
      this.dialogs.edit = false;
      this.editedItem = null;
      this.editedIndex = -1;
      this.effectiveDate = null;
    },
    saveDone() {
      this.$refs.table.getDataAsync();
    },
    async tryDelete() {
      let item = JSON.parse(JSON.stringify(this.editedItem));
      item.EffectiveDate = this.effectiveDate;
      item.IsRemoved = true;
      if (item.Relationship) {
        item.RelationshipId = item.Relationship.Id;
        delete item.Relationship;
      }
      if (item.Gender) {
        item.GenderId = item.Gender.Id;
        delete item.Gender;
      }
      delete item["@odata.context"];
      try {
        await this.updateDependant({
          plan: this.selectedPlan.Id,
          member: this.memberId,
          payload: item,
          id: this.editedItem.IdentityId,
        });
        this.color = "success";
        this.message = "globals.success"
        this.snackbar = true;
        this.dialogs.delete = false;
        this.effectiveDate = null;
        this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      }
    },
  },
};
</script>
